import React from 'react'
import { useSelector } from 'react-redux'
import { Container, Box, Icon, IconStack, Spacer, Text } from 'roadie-ui'
import Avatar from 'rui/widgets/Avatar'
import Page from 'rui/widgets/Page'
import Sidebar, { NameHeading, NameSubHeading, Section, SidebarExternalLink } from 'components/layout/Sidebar'
import { LocalizedText } from 'localization'

const RestrictedAccess: React.FC = () => {
  const isWebview = useSelector<any, boolean>((state) => state.config.isWebview)

  return (
    <Page sidebar={<RestrictedSidebar />}>
      <Container.Grid
        $justifyItems="center"
        $alignItems="center"
        $height={isWebview ? '100vh' : '60vh'}
        $backgroundColor="neutral-white"
      >
        <Container.Grid $justifyItems="center">
          <IconStack width="12rem">
            <Container.Base $backgroundColor="neutral-lightest" $height="100%" $borderRadius="100%" />
            <Box.Padding $padding="2.4rem">
              <Icon.No $color="neutral-base" />
            </Box.Padding>
          </IconStack>
          <Spacer $height="2.4rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_rui_drive_restricted_access_do_not_have_access_page" />
          </Text.Body2>
        </Container.Grid>
      </Container.Grid>
    </Page>
  )
}

const RestrictedSidebar: React.FC = () => {
  const profile = useSelector<
    any,
    {
      first_name?: string
      last_name?: string
      avatar_url: string
      member_since: string
    }
  >((state) => state.profile)
  const signupDate = profile.member_since.split('-')[0]

  return (
    <Sidebar>
      <Section>
        <Avatar size="80" url={profile.avatar_url} />
        <NameHeading>
          {profile.first_name} {profile.last_name}
        </NameHeading>
        <NameSubHeading>
          <LocalizedText translationKey="dweb_common_driver_since_date" params={{ signupDate }} />
        </NameSubHeading>
      </Section>
      <Section>
        <SidebarExternalLink
          id="sidebar-link-to-support"
          href={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/contactsupport`}
        >
          <LocalizedText translationKey="dweb_layout_drive_sidebar_email_support" />
        </SidebarExternalLink>
      </Section>
    </Sidebar>
  )
}

export default RestrictedAccess
